import React from 'react';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import s from './JournalTags.scss';
export const JournalTags = ({ tags  })=>{
    return tags ? /*#__PURE__*/ React.createElement("div", {
        className: s['tags']
    }, /*#__PURE__*/ React.createElement(FoldableTagList, {
        tags: tags
    })) : null;
};
JournalTags.displayName = 'JournalTags';
export default JournalTags;
